import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const COLUMN_MAX_WIDTH = '82.6rem';

export const PageContent = styled.div`
    padding: 4rem;
    overflow-y: auto;
`;

export const PageHeader = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    max-width: ${COLUMN_MAX_WIDTH};
`;

export const PageTitle = styled.h1`
    font-size: 2.4rem;
    font-weight: 500;
    line-height: 3rem;
    margin: 0;
    color: ${tokens.text.primary};
`;

export const Callout = styled.div`
    background-color: ${tokens.surface.subtle};
    border-radius: 8px;
    padding: 0.8rem 1.2rem;
    color: ${tokens.text.primary};
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

export const ActionRow = styled.div`
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
    width: 100%;
    max-width: ${COLUMN_MAX_WIDTH};
    margin-top: 1.6rem;
`;

export const SettingsCard = styled.div`
    box-sizing: border-box;
    margin-top: 1.6rem;
    width: 100%;
    max-width: ${COLUMN_MAX_WIDTH};
    border: 1px solid ${tokens.border.default};
    border-radius: 8px;
    padding: 2rem;
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 3.2rem;
    }
`;

export const SectionHeading = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding-bottom: 1.6rem;
`;

export const SectionTitle = styled.h2`
    font-size: 2rem;
    font-weight: 500;
    line-height: 2.6rem;
    margin: 0;
`;

export const SectionDescription = styled.p`
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${tokens.text.primary};
    margin: 0;
`;

export const EditSectionTitle = styled(SectionTitle)`
    margin-bottom: 0.4rem;
`;
